import { Component, Input } from '@angular/core';

/** Banda de accesos rápidos para la portada iGuau (Angular con NgModule). */
@Component({
  selector: 'app-iguau-accesos',
  templateUrl: './iguau-accesos.component.html',
  styleUrls: ['./iguau-accesos.component.css']
})
export class IguauAccesosComponent {
  /** Rutas configurables sin necesidad de modificar la plantilla. */
  @Input() perfilUrl = '/registro/';
  @Input() amigosUrl = '/perfiles/';
  @Input() saludUrl = '/perfil/';
  @Input() murosUrl = '/muros';

  get accesos(): { titulo: string; subtitulo: string; icono: string; url: string; etiqueta: string }[] {
    return [
      { titulo: 'Crea el perfil', subtitulo: 'de tu mascota', icono: 'fa-paw', url: this.perfilUrl, etiqueta: 'Crear el perfil de tu mascota' },
      { titulo: 'Haz nuevos', subtitulo: 'amigos', icono: 'fa-users', url: this.amigosUrl, etiqueta: 'Descubrir nuevos amigos' },
      { titulo: 'Cuida su salud', subtitulo: 'y bienestar', icono: 'fa-heart-pulse', url: this.saludUrl, etiqueta: 'Acceder a salud y bienestar' },
      { titulo: 'Comparte tus', subtitulo: 'momentos', icono: 'fa-comments', url: this.murosUrl, etiqueta: 'Explorar los muros de iGuau' }
    ];
  }

  trackByTitulo(_index: number, item: { titulo: string }): string {
    return item.titulo;
  }
}
